import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        $('.tooltip-t').tooltip({toggle: 'tooltip', placement: 'top'})
    }
}
